<template>
  <div>
    <!--美通-->
    <div v-if="r.express_company_id==581">
      <el-col style="flex:1;padding-right: 30px;" :xs="24" :lg="19" :md="18" :sm="24">
        <div style="word-wrap: break-word;border: 1px solid #DBDBDB">
          <el-row style="padding: 0.5rem;background: rgb(245, 245, 245);border-bottom: 2px solid #dbdbdb">
            <p style="font-size: 20px;line-height: 20px">
              <span>{{r.html.create_date}}</span>
              <span>订单号：{{r.html.order_id}}</span>
              <span>收件人：{{r.html.name}}</span>
            </p>
          </el-row>
          <el-row :gutter="0" type="flex" align="stretch">
            <el-col :span="18">
              <ul>
                <li class="express-html" v-for="(item,i) in r.html.items" :key="i">
                  <div class="detail-card detail-info" style="display: flex;align-items: center">
                    <div class="img-container">
                      <!--<img :src="item.js_da.photo" mode="aspectFit"/>-->
                      <a :href="`https://file.51daigou.ca/${item.js_da.photo}`" target="_blank">
                        <img :src="`https://file.51daigou.ca/${item.js_da.photo}`" mode="aspectFit"/>
                      </a>
                    </div>
                    <div style="margin-left: 0.5rem">
                      <p>
                        {{item.js_da.title}}
                      </p>
                      <div class="spec">
                        <span class="spec-item tag" v-for="(each,j) in item.js_da.pars" :key="j">{{j}}:{{each}}</span>
                      </div>
                      <div v-if="item.js_da.diy_data&&item.js_da.diy_data.remark" class="diy">
                      <span>
                        定制需求： {{item.js_da.diy_data.remark}}
                      </span>
                      </div>
                    </div>
                  </div>
                  <div class="detail-card"
                       style="margin-left: auto;margin-right: 1rem;display: flex;justify-content: space-between;width: 6rem">
                    <div>
                      C${{item.total_price}}
                    </div>
                    <div>
                      {{item.qty}}
                    </div>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :span="2" style="border-left: 1px solid #d7d7d7">
              <div class="sub-detail detail-card">
                收款:<br/>
                <span style="margin-top: 1rem ">{{getPrice(1,r.html)}}</span>
                <span style="margin-top: 1rem;color: #858585">商品:
                <span>{{getPrice(2,r.html)}}</span>
              </span>
                <span style="margin-top: 1rem;color: #858585">运费:
                <span>{{getPrice(3,r.html)}}</span>
              </span>
              </div>
            </el-col>
            <el-col :span="2" style="border-left: 1px solid #d7d7d7">
              <!--<el-col :span="3" style="border: 1px solid #d7d7d7;border-top: none;border-bottom: none">-->
              <div class="sub-detail detail-card">
                {{r.html.status_txt}}
              </div>
            </el-col>
            <el-col :span="2" style="border-left: 1px solid #d7d7d7;">
              <div class="sub-detail detail-card">
                <el-popover
                  placement="top"
                  title="信息"
                  width="400"
                  trigger="click"
                >
                  <div>
                    <div>{{trace.track_id}}</div>
                    <div v-for="(item,i) in trace.express_da" :key="i">{{item}}</div>
                  </div>
                  <a slot="reference" style="color: #858585" @click="getMTTrace()">
                    快递跟踪
                  </a>
                </el-popover>

              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col style="padding-left:50px;" :span="5">
        <div style="line-height: 1;color:#303133;">
          <template v-if="r.transport_store_number">
            <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">物流单号</p>
            <template v-if="r.transport_url">
              <p style="margin-bottom: 10px;">
                <i class="el-icon-link" style="position:relative;top:1px;"></i>
                <a class="content_link" target="_blank" :href="r.transport_url">{{ r.transport_store_number
                  }}</a>
              </p>
            </template>
            <template v-else>
              <p style="margin-bottom: 10px;">{{ r.transport_store_number }}</p>
            </template>
          </template>
          <template v-if="r.account_name">
            <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">
              物流账号
            </p>
            <p style="margin-bottom: 10px;">{{ r.account_name }}</p>
          </template>
          <template>
            <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">
              {{r.weight_label.map(item=>
              {return item.name}).join('|')}}</p>
            <p style="margin-bottom: 10px;">
              {{r.weight_label.map(item=>
              {return item.value }).join('|')}}
            </p>
          </template>
          <template>
            <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">{{r.money_label.map(item=>
              {return item.name}).join('|')}}</p>
            <p style="margin-bottom: 10px;">
            <span>
                {{r.money_label.map(item=>
            {return item.value }).join('|')}}
            </span>
            </p>
          </template>
          <template>
            <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">收件地址</p>
            <p style="margin-bottom: 10px;">
              {{r.receive_address}}
            </p>
          </template>
        </div>
      </el-col>
    </div>
    <!--华中转运-->
    <div class="table-row-content" v-else-if="r.express_company_id==794&&r.json2.length>3" style="word-wrap: break-word;">
      <el-descriptions title="运单详情" :column="3">
        <el-descriptions-item :label="r.json2[2].key">{{r.json2[2].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[1].key">{{r.json2[1].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[3].key">{{r.json2[3].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[4].key">{{r.json2[4].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[0].key">{{r.json2[0].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[6].key">{{r.json2[6].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[7].key">{{r.json2[7].value||'--'}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[8].key">{{r.json2[8].value||'--'}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[9].key">{{r.json2[9].value}}</el-descriptions-item>
        <!--<el-descriptions-item :label="r.json2[12].key">{{r.json2[12].value[r.json2[12].value.length-1].value}}</el-descriptions-item>-->
        <!--<el-descriptions-item :label="r.json2[13].key">{{r.json2[13].value}}</el-descriptions-item>-->
        <el-descriptions-item :label="r.json2[10].key">{{r.json2[10].value}}</el-descriptions-item>
      </el-descriptions>
      <el-divider content-position="left">收费详情</el-divider>
      <el-row type="flex" :gutter="24" style="padding: 10px">
        <el-col :span="12">
          <el-row class="text-gray padding-bottom-10" style=" padding-bottom: 10px;">收费项</el-row>
          <el-row class="padding-bottom-10" style=" padding-bottom: 10px;">转运费</el-row>
          <el-row class="padding-bottom-10 font-bold" style=" padding-bottom: 10px;">总费用</el-row>
        </el-col>
        <el-col :span="11" class="text-right">
          <el-row class="text-gray padding-bottom-10" style=" padding-bottom: 10px;">费用($)</el-row>
          <el-row class="padding-bottom-10" style=" padding-bottom: 10px;">{{r.json2[4].value}}</el-row>
          <el-row class="padding-bottom-10 font-bold" style=" padding-bottom: 10px;">{{r.json2[4].value}}</el-row>
        </el-col>
      </el-row>
      <el-divider content-position="left">收件人地址</el-divider>
      <el-descriptions :column="3" style="padding: 10px">
        <el-descriptions-item :label="r.json2[11].value[0].key">{{r.json2[11].value[0].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[11].value[1].key">{{r.json2[11].value[1].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[11].value[2].key">{{r.json2[11].value[2].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[11].value[3].key">{{r.json2[11].value[3].value}}</el-descriptions-item>
        <el-descriptions-item :label="r.json2[11].value[4].key">
          <el-image fit="scale-down" class="card-img" :src="r.json2[11].value[4].value"></el-image>
        </el-descriptions-item>
        <el-descriptions-item :label="r.json2[11].value[5].key">
          <el-image fit="scale-down" class="card-img" :src="r.json2[11].value[5].value"></el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider content-position="left" v-if="r.json2[14].value&&r.json2[14].value.length">附件</el-divider>
      <div class="flex flex-column text-center" v-if="r.json2[14].value&&r.json2[14].value.length">
        <i class="el-icon-folder-opened" style="font-size: 4rem"></i>
        <span class="text-gray">
                      暂无附件
          </span>
      </div>
    </div>
    <div class="table-row-content" v-else-if="r.express_company_id==794&&r.json2.length<3" style="word-wrap: break-word;">
        <span class="text-gray">
                      空状态， 暂无信息
          </span>
    </div>
    <!--转运中国-->
    <div v-else-if="r.express_company_id==899" id="content" style="word-wrap: break-word;">
      <div class="header_intro_panel">
        <table>
          <tbody>
          <tr>
            <td>
              <div class="label">{{r.json2[0].key}}：</div>
              <div class="value">
                {{r.json2[0].value}}
              </div>
            </td>
            <td>
              <div class="label">{{r.json2[1].key}}：</div>
              <div class="value">{{r.json2[1].value}}</div>
            </td>
            <td>
              <div class="label">{{r.json2[2].key}}：</div>
              <div class="value">{{r.json2[2].value}}</div>
            </td>
            <td class="status">
              <div class="label">{{r.json2[3].key}}：</div>
              <div class="value">{{r.json2[3].value}}</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="detail_info_panel">
        <dl class="list_info">
          <dd>
            <div class="label">{{r.json2[4].key}}</div>
            <div class="value">{{r.json2[4].value}}</div>
          </dd>
          <dd>
            <div class="label">{{r.json2[5].key}}</div>
            <div class="value" style="color:#F68C25;">{{r.json2[5].value}}</div>
          </dd>
          <dd>
            <div class="label">{{r.json2[6].key}}</div>
            <div class="value">{{r.json2[6].value}}</div>
          </dd>
          <dd>
            <div class="label">{{r.json2[7].key}}</div>
            <div class="value">{{r.json2[7].value}}</div>
          </dd>
          <dd>
            <div class="label">{{r.json2[8].key}}</div>
            <div class="value">{{r.json2[8].value}}</div>
          </dd>
          <dd>
            <div class="label">{{r.json2[9].key}}</div>
            <div class="value">{{r.json2[9].value}}</div>
          </dd>
        </dl>
        <dl class="chart_info">
          <dd v-for="(item,i) in r.json2[10].value" :key="i" :class="i==0?'first':''"> {{item.value.split("(")[0]}}&nbsp;
            <em>({{item.value.split("(")[1]}}</em>
          </dd>
        </dl>
      </div>
      <div class="common_panel margin-top-sm" v-if="(r.json2[11].key=='出库单包含快递包裹')">
        <div class="panel_header">
          {{r.json2[11].key}}
        </div>
        <div class="panel_content">
          <table class="common_list">
            <thead>
            <tr>
              <th>快递号码</th>
              <th>货物概述</th>
              <th>重量</th>
              <th>入库时间</th>
              <th>异常情况</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,i) in r.json2[11].value" :class="r.json2[11].value.length-1==i?'last':''">
              <template v-if="i>0">
                <td v-for="(item2,j) in item.value" :key="j">{{item2.value}}</td>
              </template>

            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="common_panel margin-top-sm">
        <div class="panel_header">
          {{r.json2[12].key}}
        </div>
        <div class="panel_content">
          <table class="common_list">
            <thead>
            <tr>
              <th v-for="(item,i) in r.json2[12].value[0].value" :key="i">{{item.value}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,i) in r.json2[12].value" :class="r.json2[12].value.length-1==i?'last':''">
              <template v-if="i>0">
                <td v-for="(item2,j) in item.value" :key="j">{{item2.value}}</td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="common_panel margin-top-sm">
        <div class="panel_header">
          {{r.json2[13].key}}
        </div>
        <div class="panel_content">
          <table class="common_list">
            <thead>
            <tr>
              <th v-for="(item,i) in r.json2[13].value[0].value" :key="i">{{item.value}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,i) in r.json2[13].value" :class="r.json2[13].value.length-1==i?'last':''">
              <template v-if="i>0">
                <td v-for="(item2,j) in item.value" :key="j">{{item2.value}}</td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
    <!--转运国际-->
    <div v-else-if="r.express_company_id==896">
      <div style="border: 1px solid #ccc;">
        <table class="table table-bordered" style="margin-top: 0px">
          <tbody>
          <tr style="background-color: #fff6dc;">
            <td>
              <input id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_CHK_SELECTED" type="checkbox"
                     name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$CHK_SELECTED">
              <input type="hidden" name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$hSID"
                     id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_hSID" value="4255480">
              <span class="tipColor">
              <!--批次ID：9298&nbsp;&nbsp;-->
              转运单号
            </span>：
              <span class="tipColor">
              <a :href="`${r.json2[1].value}`"
                 target="_blank">{{r.json2[0].value}}（点击跟踪）</a>
            </span>
              <div class="redtip">

              </div>
            </td>
            <td><span class="tipColor">当前状态
          </span>：<span class="tipColor">
            {{r.json2[2].value}}  </span>
              <div>
              </div>
            </td>
            <td><span style="">建单时间</span>：<span style="">{{r.json2[3].value}}</span><br>
              <div>
              </div>
            </td>
            <!--<td style="text-align: right;">-->
            <!--<input type="submit" name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$BTN_RECEIVE_STATE" value="收货"-->
            <!--onclick="return confirm('确认操作吗？');" id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_BTN_RECEIVE_STATE"-->
            <!--class="btn-search">-->


            <!--<input type="submit" name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$BTN_MSG" value="留言"-->
            <!--id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_BTN_MSG" class="btn-search">-->
            <!--</td>-->
          </tr>
          </tbody>
        </table>
        <table class="table table-bordered">
          <tbody>
          <tr>
            <td style="border-right: 1px solid #ccc; vertical-align: top; width: 300px; line-height: 24px;">
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">运单类型</span>：
                <span
                  id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_ctrlYunDanType_LT_SHOW_INFO">{{r.json2[4].value}}</span>
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">口岸</span>：{{r.json2[5].value}}
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">危险品</span>：{{r.json2[6].value}}
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">保险</span>：{{r.json2[7].value}}
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">重量(KG)</span>：{{r.json2[8].value}}
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">选定打包员</span>：{{r.json2[9].value}}
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">优惠券金额</span>：{{r.json2[10].value}}
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">国内单号</span>：&nbsp;{{r.json2[11].value}}
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc;">
                <span class="tipColor">客户备注</span>：<input name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$TXT_USER_REMARK"
                                                          type="text" :value="`${r.json2[12].value}`" maxlength="512"
                                                          id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_TXT_USER_REMARK"
                                                          disabled="disabled" class="form-control">
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc; background: #f9fdff;">
                <span class="tipColor">理赔状态</span>：
                <span disabled="disabled">
                <input id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_CheckBox2" type="checkbox"
                       name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$CheckBox2"
                       :checked="`${r.json2[13].value=='未勾选'?'':'checked'}`"
                       disabled="disabled"></span>
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc; background: #f9fdff;">
                <span class="tipColor">直发运单</span>：
                <span disabled="disabled">
                <input id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_CheckBox1" type="checkbox"
                       name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$CheckBox1"
                       :checked="`${r.json2[14].value=='未勾选'?'':'checked'}`"
                       disabled="disabled"></span>
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc; background: #f9fdff;">
                <span class="tipColor">问题件描述</span>：{{r.json2[15].value}}

              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc; background: #f9fdff;">
                <span class="tipColor">晒单状态</span>：{{r.json2[16].value}}

                <span id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_ctrlDoStatus_LT_SHOW_INFO">等待处理</span>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <div style="width: 100%; border-bottom: 1px dashed #ccc; background: #f1f1f1; height: 30px;">
                <div style="float: left;" class="tipColor">
                  打包照片：
                </div>
                <div style="float: left; padding-top: 3px;">
                  &nbsp;<a
                  :href="`${r.json2[17].value}`"
                  target="_blank"><img :src="handleUrl(`${r.json2[17].value}`)"
                                       style="max-height: 30px; max-width: 30px;"></a>
                </div>
              </div>
              <div style="vertical-align: bottom;">
                <div style="padding-top: 20px; padding-bottom: 10px;">

                </div>
              </div>
            </td>
            <td style="border-right: 1px solid #ccc; vertical-align: top; width: 300px;">
              <div class="tipColor" style="float: left;">
                包裹明细
              </div>
              <div style="float: left; width: 100%;">
                <div style="float: left; width: 30px;">
                  序号
                </div>
                <div style="float: left;">
                  美国运单号
                </div>
                <div style="float: right;">
                  入库重量(KG)
                </div>
              </div>
              <div style="clear: both; float: left; width: 100%;">
                <div style="float: left; width: 30px;"> {{r.json2[18].value[1].value[0].value}}、</div>
                <div style="float: left; border-bottom: 1px dashed #ccc;">{{r.json2[18].value[1].value[1].value}}</div>
                <div style="float: right;"> {{r.json2[18].value[1].value[2].value}}</div>
              </div>
            </td>
            <td style="border-right: 1px solid #ccc; vertical-align: top; width: 200px;"><span
              class="tipColor">申报明细</span>：<br>
              {{r.json2[19].value}}<br>
            </td>
            <td
              style="border-right: 1px solid #ccc; vertical-align: top; background-color: #fdf1f1; line-height: 30px; text-align: right; width: 140px;">
              <div>
                运费(或预估)
              </div>
              <div>
                合箱费
              </div>
              <div>
                保费
              </div>
              <div>
                逾期仓储费
              </div>

              <div>
                预缴关税
              </div>
              <div>
                其它费用

              </div>
              <div style="border-bottom: 1px solid #ccc; width: 100%;">
              </div>
              <div>
                使用积分减抵
              </div>
              <div>
                VIP折扣
              </div>
              <div>
                使用优惠码减抵
              </div>
              <div style="border-bottom: 1px solid #ccc; width: 100%;">
              </div>
              <div style="color: #d75e16; font-weight: bold;">
                实付合计<br>
                <br>

              </div>
            </td>
            <td style="vertical-align: top; line-height: 30px; width: 60px;">
              <div>
                {{r.json2[20].value}}
              </div>
              <div>
                {{r.json2[21].value}}
              </div>
              <div>
                {{r.json2[22].value}}
              </div>
              <div>
                {{r.json2[23].value}}
              </div>

              <div>
                {{r.json2[24].value}}
              </div>
              <div>
                {{r.json2[25].value}}
              </div>
              <div style="border-bottom: 1px solid #ccc; width: 100%;">
              </div>
              <div>
                {{r.json2[26].value}}
              </div>
              <div>
                {{r.json2[27].value}}
              </div>
              <div>
                {{r.json2[28].value}}
              </div>
              <div style="border-bottom: 1px solid #ccc; width: 100%;">
              </div>
              <div style="color: #d75e16; font-weight: bold;">
                {{r.json2[29].value}}<br>
                (已付）<br>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <table class="table table-bordered" style="background-color: #f5f8fc;">
          <tbody>
          <tr>
            <td><span class="tipColor">收件人姓名</span>：<span class="tipColor">{{r.json2[30].value[0].value}}</span></td>
            <td><span class="tipColor">收件人电话</span>：<span class="tipColor">{{r.json2[30].value[1].value}}</span></td>
            <td><span class="tipColor">地址</span>：<span class="tipColor">{{r.json2[30].value[2].value}}</span></td>
            <td><span class="tipColor">邮编</span>：<span class="tipColor">{{r.json2[30].value[3].value}}</span></td>
            <!--<td>-->

            <!--<span disabled="disabled"><input id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_CHK_OVER_EDIT_FLAG"-->
            <!--type="checkbox"-->
            <!--name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$CHK_OVER_EDIT_FLAG"-->
            <!--disabled="disabled"><label-->
            <!--for="ctl00_ContentPlaceHolder1_Repeater1_ctl00_CHK_OVER_EDIT_FLAG">已修改</label></span>-->
            <!--</td>-->
            <td style="text-align: right;">
              <span class="tipColor">身份证</span>：<span class="tipColor">
          <input type="hidden"
                 name="ctl00$ContentPlaceHolder1$Repeater1$ctl00$hImg"
                 id="ctl00_ContentPlaceHolder1_Repeater1_ctl00_hImg">
          <a @click="openNew(`${r.json2[30].value[4].value}`)">正面</a>
            &nbsp;
            <a @click="openNew(`${r.json2[30].value[5].value}`)">反面</a>
          </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--必得-->
    <BD class="bd" v-else-if="r.express_company_id==1557" :json="r.json2"></BD>
    <DF class="df" v-else-if="r.express_company_id==1573" :json="r.json2"></DF>
    <STUK class="styg" v-else-if="r.express_company_id==1587" :json="r.json2"></STUK>
    <div v-else style="word-wrap: break-word" v-html="handleHtml(r)"></div>
  </div>


</template>

<script>
  import api from '../../../services/api.js'
  import BD from './bd/index'
  import DF from './df/index'
  import STUK from './stuk/index'

  let _ = require('lodash')
  export default {
    name: 'BillBody',
    props: ['r', 'index', 'taskDisplay'],
    components: {
      BD: BD,
      DF:DF,
      STUK:STUK
    },
    data() {
      return {
        trace: {},
        step1: [
          {label: '待入库', value: '1'},
          {label: '已入库', value: '2'},
          {label: '待扣款', value: '3'},
          {label: '待充值', value: '4'},
          {label: '已支付', value: '5'},
          {label: '待出库', value: '6'},
          {label: '已出库', value: '7'},
          {label: '国内派送', value: '8'},
          {label: '已签收', value: '9'},
        ]
      }
    },
    created() {
      this.r.json2 = JSON.parse(this.r.json);
      if (this.r.express_company_id == '896') {
        if (this.r.json2[17].key == '包裹明细') {
          this.r.json2.splice(17, 0, {value: ''})
        }
      }
      if (this.r.express_company_id == '1573') {
        if(this.r.json2[16].key=='包裹备注'){
         this.r.json2.splice(16,0,{key:'总价格',value:''})
        }
      }
    },
    methods: {
      handleUrl(v) {
        let arr = v.split('PIC_PATH=');
        if (arr.length == 1) {
          return arr[0]
        }
        return arr[1];
      },
      openNew(v) {
        window.open(v, 'blank')
      },
      getMTTrace(obj) {
        let id = this.r.html.id
        api.fetchMTTrace(this, {id: id}).then(res => {
          try {
            this.trace = res.body.result.data.d.list[0]
          } catch (e) {
            console.error('fetch mt trace error:id=' + obj.id)
          }
        })
      },
      getPrice(type, obj) {
        let result = '--';
        if (type == 1) {
          result = obj.items_price;
        } else if (type == 2) {
          result = obj.items_price;
        } else if (type == 3) {
          result = obj.exp_price;
        }
        return 'C$' + result;
      },
      handleHtml(r) {
        return r.html
      },
      displayFirstLine(str) {
        return str.split("\<br>")[0]
      },

    }
  }
</script>
<style scoped>
  @import './zyzg.css';
  @import './bootstrap.css';
</style>

<style lang="scss">
  .detail-card {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .express-html {
    display: flex;

    &:not(:first-child) {
      border-top: 1px solid #D7D7D7
    }
  }

  .sub-detail {
    display: flex;
    text-align: center;
    flex-direction: column;
  }

  .detail-info {
    font-size: 12px;
    padding-left: 0.5rem;

    .spec {
      margin-top: 1rem;

      .spec-item {
        padding: 2px;
        border: 1px solid #D7D7D7;

        &:not(:first-child) {
          margin-left: 1rem;
        }
      }
    }

    .diy {
      margin-top: 1rem;

      span {
        padding: 2px;
        border: 1px solid #b2b2b2;
      }
    }
  }


  .img-container {
    width: 120px;
    height: 120px;

    img {
      width: 120px;
      height: 120px;
    }
  }

  .content_link {
    color: #303133;
  }

  .product-container {
    padding: 15px 0;
    border-bottom: 1px solid #D7D7D7;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &.order {
      display: flex;
      justify-content: space-between;
    }
  }

  .product-wrapper {
    display: flex;
    justify-content: space-between;

    .product-wrapper-left.lika {
      margin-left: 237px;

      &.taskDisplay {
        margin-left: 200px;
      }
    }

    .product-wrapper-right {
      text-align: right;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.order {
      flex: 1;
      border-right: 1px solid #D7D7D7;
      padding-right: 25px;
      line-height: 1;
    }

    .product-wrapper-right.order p {
      color: #888888;
    }
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_bill/BillBody.vue